import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getLocations } from "helpers/repository"
import {sitename} from "../../../../constants/constants";

const Locations = props => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const [totalData, setTotalData] = useState(0)
  useEffect(() => {
    getLocations(getLocationsSuccess, getLocationsError)
    // dispatch(getAllSports())
  }, [])

  const getLocationsSuccess = res => {
    setData(res?.data?.data ?? [])
    setTotalData(res.data.total)
  }

  const getLocationsError = error => {}

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Locations" />
        </Container>
        <Table
          data={data}
          getLocations={() => {
            getLocations(getLocationsSuccess, getLocationsError)
          }}
          count={totalData}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Locations)
